exports = module.exports = require("../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".dialogOptions-2RRHx .icon-YI7-1 {\n  width: 40px;\n}\n.dialogOptions-2RRHx .link-2lP7e {\n  line-height: 40px;\n  font-size: 16px;\n}", ""]);

// Exports
exports.locals = {
	"dialogOptions": "dialogOptions-2RRHx",
	"icon": "icon-YI7-1",
	"link": "link-2lP7e"
};